/*
 * @Description: 执行历史 api
 * @Date: 2020-07-23 13:49:00
 * @LastEditTime: 2020-07-23 13:51:27
 */ 

import request from '@/utils/request.js'

export function historyList(params) {
    return request({
        url: `/api/channel/finished`,
        method: 'get',
        params
    })
}

export function historyDetail(data) {
    return request({
        url: `/api/channel/finished/${data.id}/`,
        method: 'get',
        data
    })
}